import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ErrorService } from '../../../error';
import { KnownIpAddressFormModel, KnownIpAddressModel } from './types';
import { catchError } from 'rxjs/operators';
import { CrudType } from '../../../service/message/types';
import { MessageService } from '../../../service/message/message.service';

@Injectable({
  providedIn: 'root',
})
export class KnownIpAddressApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
    private readonly messageService: MessageService,
  ) {}

  getById = (id: number): Observable<KnownIpAddressModel> => {
    let url = this.formatUrl([id.toString()]);
    return this.httpClient.get<KnownIpAddressModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  update = (
    knownIpAddressFormModel: KnownIpAddressFormModel,
  ): Observable<KnownIpAddressModel> => {
    let url = this.formatUrl([knownIpAddressFormModel.id.toString()]);
    return this.httpClient
      .put<KnownIpAddressModel>(url, knownIpAddressFormModel, {
        observe: 'response',
      })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.update),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.knownIpAddress.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
